import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button, Row, Col } from 'reactstrap';

//Components
import ReactFlowComponent from '../../../../../components/ReactFlowComponent';
import ModalCustomized from '../../../../../components/Modal/Modal';
import TextField from '../../../../../components/TextField';
import mascaras from '../../../../../helpers/mascaras';

//Helpers
import { validarCampos, objCampo } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage, showQuestion } from '../../../../../helpers/message';

//Api
import modelosEmail_api from '../../../../../api/modelosEmail_api';
import integracao_api from '../../../../../api/integracao_api';
import roteiroDeFiscalizacao_api from '../../../../../api/roteiroDeFiscalizacao_api';

//Context
import { useAuth } from '../../../../../context/auth';
import layoutDiarioOficial_api from '../../../../../api/layoutDiarioOficial_api';

function initialStateAcao(idPai = null) {
    return {
        identificacaoBotao: "",
        situacaoInfracao: "",
        excluido: "false",
        controleBoleto: "",
        prazoVencimentoBoleto: null,
        modeloEmail_Id: null,
        roteiroFiscalizacaoEtapa_Id: idPai,
        executaComPrazoExcedido: "false",
        inscreverEmDividaAtiva: "false",
        executaComBoletoLiquidado: "false",
        executaComRecebimentoEmail: "false",
        cor: "success",
        orientacoes: "",
        modeloEmailMunicipe_Id: null,
        informarNumeroProcesso: "false",
        exibirParaExecucao: "true",
        layoutExportacaoDiarioOficial_Id: null,
        proximasAcoes: [],
        acoesIntegracoes: [],
        indiceAprovacaoColegiado: null
    }
}

export default function Workflow({ roteiroFiscalizacao, loadRoteiroFiscalizacao, editavel }) {
    const { setLoading } = useAuth();

    //Estado que guarda as opções de modelos de emails
    const [modelosEmail, setModelosEmail] = useState([]);

    //Estado que guarda os valores da ação a ser adicionada
    const [acao, setAcao] = useState(initialStateAcao());

    //State para pegar os methods de cada secretária
    const [listmethodsIntregacao, setListMethodsIntregacao] = useState([]);

    //State para lista de layouts diario
    const [listLayoutDiarioOfical, setListLayoutDiarioOfical] = useState([]);

    //Estado de controle das açoes que serão exibidas no fluxograma
    const [acoes, setAcoes] = useState([]);

    //Estado de controle dos erros nos campos de adicionar açãoF
    const [errors, setErrors] = useState({});

    //Campos obrigatorios para adicionar uma ação
    const campos = [
        objCampo({ name: "identificacaoBotao", required: true }),
        objCampo({ name: "situacaoInfracao", required: true })
    ];

    //Estado de controle de visibilidade do modal que adiciona a nova ação
    const [visibleModal, setVisibleModal] = useState(false);

    const [campoIndiceColegiado, setCampoIndiceColegiado] = useState(false);

    const ref = useRef(null);

    //Função de controle de visibilidade do modal
    const toggleModal = (idPai) => {
        setVisibleModal(!visibleModal)
        setCampoIndiceColegiado(false);
        if (!visibleModal)
            setAcao(initialStateAcao(idPai));
    };

    //Função de editar uma ação
    const editarAcao = (idfilho, idPai, acaoId) => {
        const _acao = roteiroFiscalizacao.acoes.find(value =>
            value.id == acaoId &&
            value.roteiroFiscalizacaoEtapa_Id == idPai
        );
        if (_acao) {
            setAcao(_acao);
            setVisibleModal(true);
        }
    }

    //Função de remover uma ação (agora apenas quebra a ligação)
    const removerAcao = () => {
        showQuestion("Tem certeza?", "Tem certeza de que deseja deletar essa ação?\n Esta ação é irreversível", "info",
            async (confirmation) => {
                if (confirmation) {
                    setLoading(true);
                    try {
                        await roteiroDeFiscalizacao_api.DeleteRoteiroFiscalizacaoAcao(acao.id);
                        toggleModal();
                        await loadRoteiroFiscalizacao();
                    } catch (e) {
                        showMessage("Erro", e.message, "error", null);
                    } finally {
                        setLoading(false);
                    }
                }
            })
    }

    //Função de onChange dos campos do modal
    const onChange = (e) => {
        const { name, value } = e.target;
        const _acao = {
            ...acao,
            [name]: value
        }
        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_acao, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setAcao(_acao);
    }

    //Função de onchange para o campo de etapa
    const onChangeEtapa = (value, e) => {
        setAcao({
            ...acao,
            proximasAcoes: value
                ? [{
                    ...acao.id ? { roteiroFiscalizacaoAcao_Id: acao.id } : {},
                    roteiroFiscalizacaoEtapa_Id: value.value
                }] : []
        });
    }

    //onChange para o campo de modelo de email
    const onChangeSelect = (value, e) => {
        setAcao({
            ...acao,
            [e.name]: value ? value.value.toString() : null,
        });
    }

    //onChange para os multiSelects
    const onChangeMultiSelect = (e, select) => {
        const { name } = select;
        setAcao({
            ...acao,
            [name]: e && e.length > 0 ? e.map(value => value.value) : []
        })
    }

    //Carrega os modelos de emails para cadastro de etapas
    const loadModelosEmail = () => {
        setLoading(true);
        modelosEmail_api.getListAtivos()
            .then(response => {
                setModelosEmail(response.data);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    //Carrega as integrações pelo tipo
    const loadMethodsIntregacao = () => {
        setLoading(true);
        integracao_api.GetListWorkflow("POST")
            .then(response => {
                setListMethodsIntregacao(response.data);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    const loadLayoutsDiarioOficial = () => {
        setLoading(true);
        layoutDiarioOficial_api.getList()
            .then(response => {
                setListLayoutDiarioOfical([{ id: "Nenhum", identificacao: "Nenhum" }, ...response.data]);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    //Função que inicializa o vetor das ações do fluxograma
    const loadAcoes = (novasAcoes) => {
        const _acoes = [...novasAcoes ? novasAcoes : roteiroFiscalizacao.acoes];
        if (_acoes.length === 0) {
            setAcoes(roteiroFiscalizacao.etapas.filter(value => {
                return value.andamento === "Inicial"
            }).map(value => {
                return { name: value.descricao, hash: value.id, etapaInicial: true }
            }));
            return;
        }

        console.log(_acoes)
        setAcoes([
            ...roteiroFiscalizacao.etapas.filter(value => {
                return value.andamento === "Inicial"
            }).map(value => {
                return { name: value.descricao, hash: value.id, etapaInicial: true }
            }),
            ..._acoes.map(acao => {
                if (!acao?.proximasAcoes || acao.proximasAcoes.length === 0) return null;
                const proximasEtapaId = acao.proximasAcoes[0].roteiroFiscalizacaoEtapa_Id;
                const etapaSelecionada = roteiroFiscalizacao.etapas.find(etapa => etapa.id == proximasEtapaId);
                
                if (!etapaSelecionada) return null;

                return {
                    name: etapaSelecionada.descricao,
                    acaoId: acao.id,
                    hash: proximasEtapaId,
                    hashPai: acao.roteiroFiscalizacaoEtapa_Id,
                    textoConector: acao.identificacaoBotao,
                    etapaFinal: etapaSelecionada.andamento === "Final"
                }
            }).filter(item => item !== null)
        ]
        )
    }

    //Função que adiciona a ação informada
    const onSubmit = async () => {
        const _errors = validarCampos(acao, campos);
        if (!acao.proximasAcoes[0] || !acao.proximasAcoes[0].roteiroFiscalizacaoEtapa_Id) {
            _errors[0].etapa = { message: "" };
            _errors[1].push({ name: "etapa", required: true });
        }

        setErrors(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }

        let _acao = { ...acao };
        _acao.layoutExportacaoDiarioOficial_Id = _acao.layoutExportacaoDiarioOficial_Id == "Nenhum" ? null : _acao.layoutExportacaoDiarioOficial_Id;

        setLoading(true);

        try {
            if (!!_acao.id) {
                // Edição normal
                delete _acao.proximasAcoes;
                delete _acao?.etapas;
                await roteiroDeFiscalizacao_api.PutRoteiroFiscalizacaoAcao(_acao);
            } else {
                await roteiroDeFiscalizacao_api.PostRoteiroFiscalizacaoAcao(_acao);
            }

            toggleModal(null);
            await loadRoteiroFiscalizacao();
        } catch (error) {
            showMessage("Error", error?.message ?? "Error na operação.", "error", null)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadModelosEmail();
        loadMethodsIntregacao();
        loadLayoutsDiarioOficial();
        setLoading(true);
        loadAcoes();
    }, []);

    useEffect(() => {
        loadAcoes();
    }, [roteiroFiscalizacao]);

    useEffect(() => {
        if (roteiroFiscalizacao?.etapas?.find(x => x.id == acao.roteiroFiscalizacaoEtapa_Id)?.exigeVotacaoColegiado) {
            setCampoIndiceColegiado(true);
        }
    }, [acao]);

    return (
        <>
            <div className='d-flex align-items-center justify-content-between'>
                <h5 className='mb-3'>Workflow</h5>
                <div className="text-muted small">
                    <i className="fas fa-info-circle me-1"></i>
                    Agora é possível deletar ações e reconectar ações soltas automaticamente.
                </div>
            </div>
            <ModalCustomized title={acao.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Cadastrar"} isOpen={visibleModal} toggle={toggleModal} btnClose={true}>
                <Row>
                    <Col md={12} lg={4}>
                        <TextField
                            label={"* Identificação"}
                            name={"identificacaoBotao"}
                            value={acao.identificacaoBotao}
                            onChange={onChange}
                            invalid={errors.identificacaoBotao}
                            maxLength={70}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={4}>
                        <TextField
                            label={"* Etapa"}
                            name={"etapa"}
                            type={"select"}
                            searchable
                            value={acao.proximasAcoes.length > 0
                                ? roteiroFiscalizacao.etapas.filter(value => value.id == acao.proximasAcoes[0].roteiroFiscalizacaoEtapa_Id).map(value => {
                                    return { value: value.id.toString(), label: value.descricao };
                                })[0]
                                : null}
                            onChange={onChangeEtapa}
                            options={roteiroFiscalizacao.etapas.map(value => {
                                return { value: value.id.toString(), label: value.descricao }
                            })}
                            invalid={errors.etapa}
                            disabled={!!acao.id}
                        />
                    </Col>
                    <Col md={12} lg={4}>
                        <TextField
                            type={"select"}
                            label="* Controle Boleto"
                            name={"controleBoleto"}
                            options={
                                [
                                    { label: "Nenhum", value: "" },
                                    { label: "Gerar Boleto", value: "Gerar Boleto" },
                                    { label: "Cancelar Boleto", value: "Cancelar Boleto" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.controleBoleto}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={6}>
                        <TextField
                            label={"Modelo de e-mail"}
                            name={"modeloEmail_Id"}
                            onChange={onChangeSelect}
                            type={"select"}
                            searchable
                            options={modelosEmail.map(value => { return { value: value.id, label: value.identificacao } })}
                            value={
                                acao.modeloEmail_Id ?
                                    modelosEmail.filter(documento => acao.modeloEmail_Id == documento.id)
                                        .map(value => { return { value: value.id, label: value.identificacao } })[0]
                                    : null
                            }
                            invalid={!!errors.modeloEmail_Id}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={6}>
                        <TextField
                            label={"Modelo e-mail municipe"}
                            name={"modeloEmailMunicipe_Id"}
                            onChange={onChangeSelect}
                            type={"select"}
                            searchable
                            options={modelosEmail.map(value => { return { value: value.id.toString(), label: value.identificacao } })}
                            value={
                                acao.modeloEmailMunicipe_Id ?
                                    modelosEmail.filter(documento => acao.modeloEmailMunicipe_Id == documento.id)
                                        .map(value => { return { value: value.id.toString(), label: value.identificacao } })[0]
                                    : null
                            }
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={4}>
                        <TextField
                            label={"* Situação infração"}
                            name={"situacaoInfracao"}
                            type={"text"}
                            value={acao.situacaoInfracao}
                            onChange={onChange}
                            invalid={errors.situacaoInfracao}
                            maxLength={70}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={4}>
                        <TextField
                            type={"select"}
                            label="* Executar esta ação quando o prazo for excedido?"
                            name={"executaComPrazoExcedido"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.executaComPrazoExcedido}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={4}>
                        <TextField
                            type={"select"}
                            label="* Executar esta ação quando o boleto for liquidado?"
                            name={"executaComBoletoLiquidado"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.executaComBoletoLiquidado}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={4}>
                        <TextField
                            type={"select"}
                            label="* Inscrever em Dívida Ativa ao executar esta ação?"
                            name={"inscreverEmDividaAtiva"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.inscreverEmDividaAtiva}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={3}>
                        <TextField
                            type={"select"}
                            label="* Exibir para execução?"
                            name={"exibirParaExecucao"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.exibirParaExecucao}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={6} lg={2}>
                        <TextField
                            label={"Cor"}
                            name={"cor"}
                            onChange={onChange}
                            type={"select"}
                            options={[
                                { label: "Verde", value: "success" },
                                { label: "Azul", value: "primary" },
                                { label: "Amarelo", value: "warning" },
                                { label: "Vermelho", value: "danger" },
                            ]}
                            value={
                                acao.cor
                            }
                            invalid={!!errors.cor}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={3}>
                        <TextField
                            type={"select"}
                            label="* Informar número processo?"
                            name={"informarNumeroProcesso"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.informarNumeroProcesso}
                            disabled={!editavel}
                        />
                    </Col>
                    {campoIndiceColegiado &&
                        <Col md={12} lg={4}>
                            <TextField
                                type={"text"}
                                label="Índice de Aprovação Colegiado"
                                name={"indiceAprovacaoColegiado"}
                                mask={mascaras.numeroMask}
                                onChange={onChange}
                                value={acao.indiceAprovacaoColegiado}
                                disabled={!editavel}
                                invalid={!!errors.indiceAprovacaoColegiado}
                            />
                        </Col>}
                    <Col md={12} lg={4}>
                        <TextField
                            type={"select"}
                            label="Layout exportação diário oficial"
                            name={"layoutExportacaoDiarioOficial_Id"}
                            options={listLayoutDiarioOfical.map(value => { return { value: value.id.toString(), label: value.identificacao } })}
                            onChange={onChange}
                            value={acao.layoutExportacaoDiarioOficial_Id}
                            disabled={!editavel}
                        />
                    </Col>
                    {acao.controleBoleto == "Gerar Boleto" &&
                        <>
                            <Col md={6} lg={3}>
                                <TextField
                                    type={"text"}
                                    label="* Prazo Vencimento do Boleto"
                                    name={"prazoVencimentoBoleto"}
                                    mask={mascaras.numeroMask}
                                    onChange={onChange}
                                    value={acao.prazoVencimentoBoleto}
                                    disabled={!editavel}
                                />
                            </Col>
                        </>
                    }
                    <Col md={12} lg={3}>
                        <TextField
                            type={"select"}
                            label="* Executa com Recebimento E-mail?"
                            name={"executaComRecebimentoEmail"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.executaComRecebimentoEmail}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={12}>
                        <TextField
                            name={"acoesIntegracoes"}
                            label={"Integrações"}
                            multiple
                            type={"select"}
                            value={
                                listmethodsIntregacao.filter(r => acao.acoesIntegracoes.some(x => x == r.id))
                                    .map(v => { return { value: v.id.toString(), label: v.identificacao } })
                            }
                            options={
                                listmethodsIntregacao.filter(r => !acao.acoesIntegracoes.some(x => x == r.id))
                                    .map(v => { return { value: v.id.toString(), label: v.identificacao } })
                            }
                            onChange={onChangeMultiSelect}
                            invalid={!!errors.regionais}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md={12} lg={12}>
                        <TextField
                            label={"Orietacões"}
                            name={"orientacoes"}
                            onChange={onChange}
                            type={"textarea"}
                            value={acao.orientacoes}
                            invalid={!!errors.orientacoes}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col className={`d-flex align-items-center justify-content-center my-3 ${editavel ? "" : "d-none"}`} md="12" lg="12">
                        <Button color={acao.id ? "warning text-white" : 'success'} className='px-5' onClick={onSubmit}>
                            {acao.id
                                ?
                                <><FontAwesomeIcon icon={faEdit} /> Editar</>
                                :
                                "+ Cadastrar"
                            }
                        </Button>
                        {acao.id && editavel && (
                            <Button color='danger' onClick={removerAcao} className='px-5 ms-3'>
                                <FontAwesomeIcon icon={faTrash} /> Deletar Ação
                            </Button>
                        )}
                    </Col>
                </Row>
            </ModalCustomized>
            {acoes.length > 0 &&
                <div style={{ height: `60vh` }} >
                    <ReactFlowComponent
                        nodes={acoes}
                        editavel={editavel}
                        onClickAdicionar={toggleModal}
                        onClickConector={editarAcao}
                    />
                </div>
            }
        </>
    )
}